import { USER_FAILED, USER_LOADING, USER_REMOVE, USER_SUCCESS } from "../types";

interface UserCrudState {
  loading: boolean;
  error: string | null;
  status: number | null;
  users: any;
  request: string | null;
}

const initialState: UserCrudState = {
  loading: false,
  error: null,
  status: null,
  users: null,
  request: null,
};

export const userCrudReducer = (
  state = initialState,
  action: {
    type: string;
    loading?: boolean;
    payload?: any;
    status?: number;
    error?: string;
    request?: string;
  }
): UserCrudState => {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        loading: true,
      };

    case USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
        status: action.status ?? null,
        error: null,
        request: action.request ?? null,
      };

    case USER_FAILED:
      return {
        ...state,
        loading: false,
        status: action.status ?? null,
        error: action.error ?? null,
        request: action.request ?? null,
      };

    case USER_REMOVE:
      return initialState;

    default:
      return state;
  }
};
